import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ratings',
  templateUrl: './ratings.component.html',
  styles: [
  ]
})
export class RatingsComponent implements OnInit {

  envir = environment;

  constructor() { }

  ngOnInit(): void {
  }

}
